import { defineStore } from 'pinia';

export const useBannerStore = defineStore('bannerStore', {
  state: (): { message: string | undefined; closable: boolean } => ({
    message: undefined,
    closable: true,
  }),
  actions: {
    setBanner(message: string | undefined = undefined, closable = true) {
      this.message = message;
      this.closable = closable;
    },
  },
});
